import React from 'react';
import * as S from './NameChangeErrorPop.styles';

import IconSelector from '@ibibo/icon-selector';

const NameChangeStatusPop = ({data, navigateToMyTrips}) => {
  const {msg, status_color, sub_msg = ''} = data;
  return(
    <S.CancelStatusPopMainWrap>
      <S.StatusHeadWrap color={status_color}>
        <S.StatusTextWrap>
          <S.StatusText>{msg ? msg : 'Something went wrong'}</S.StatusText>
        </S.StatusTextWrap>
        <S.StatusImgWrap>
          <IconSelector iconKey='cancelsubmit'/>
        </S.StatusImgWrap>
      </S.StatusHeadWrap>
      <S.StatusInfoWrap>
        <S.StatusInfoText>{sub_msg}</S.StatusInfoText>
        <S.StatusBtnWrap onClick={navigateToMyTrips}>
          <S.StatusBtn>BACK TO MY BOOKING</S.StatusBtn>
        </S.StatusBtnWrap>
      </S.StatusInfoWrap>
    </S.CancelStatusPopMainWrap>
  );
}

export default NameChangeStatusPop;